import { ReactNode } from 'react'
import {
  StyledTabContent,
  StyledLeftColumn,
  StyledRightColumn,
  StyledTabContentWrapper,
} from './styles'

type Props = {
  leftColumn: ReactNode
  rightColumn: ReactNode
  className?: string
}

export const TabContent = ({ leftColumn, rightColumn, className }: Props) => {
  return (
    <StyledTabContentWrapper className={className}>
      <StyledTabContent>
        <StyledLeftColumn>{leftColumn}</StyledLeftColumn>
        <StyledRightColumn>{rightColumn}</StyledRightColumn>
      </StyledTabContent>
    </StyledTabContentWrapper>
  )
}
